const FilterPanel = ({ fromRow, toRow, setFromRow, setToRow, handleFilter }) => (
  <div className="mb-4 flex items-center gap-3 px-2">
    <label className="flex items-center gap-2">
      Từ dòng:
      <input
        type="number"
        value={fromRow}
        onChange={(e) => setFromRow(e.target.value)}
        className="w-20 border rounded px-2 py-1"
      />
    </label>
    <label className="flex items-center gap-2">
      Đến dòng:
      <input
        type="number"
        value={toRow}
        onChange={(e) => setToRow(e.target.value)}
        className="w-20 border rounded px-2 py-1"
      />
    </label>
    <button
      onClick={handleFilter}
      className="bg-green-600 text-white px-4 py-1 rounded"
    >
      Filter
    </button>
  </div>
);
export default FilterPanel;
